
import { useState, useEffect, useCallback } from 'react';
import { organizationService } from '../Services/organizationService';
import { useDispatch } from 'react-redux';
import { handleApiError } from '../Utils/ApiErrorHandler';
import { setSuccessSnack } from '../Reducers/snackSuccess';

const useGetOrganization = () => {
    const dispatch = useDispatch();

    const [features, setList] = useState([]);
    const [allFeatures, setAllFeatures] = useState([]);
    const [loading, setLoading] = useState(true);

    // Separate loading states
    const [updating, setUpdating] = useState(false);

    const fetchFeatures = useCallback(async() => {
        setLoading(true); 
        try {
            const data = await organizationService.getOrganizationFeatures();
            setList(data);
            return data;
        } catch (error) {
            return handleApiError(error, dispatch, "get districts")
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchAllFeatures = useCallback(async() => {
        setLoading(true); 
        try {
            const data = await organizationService.getFeatures();
            setAllFeatures(data);
            return data;
        } catch (error) {
            return handleApiError(error, dispatch, "get districts")
        } finally {
            setLoading(false);
        }
    }, []);
      
    const updateFeatures = async (values) => {
    try {
        setUpdating(true);
        const data = await organizationService.updateOrganizationFeatures(values);
        if (data.status === 'OK') {
            console.log(data.status)
            dispatch(setSuccessSnack({
                title: 'Success', 
                body: 'Updated features'
            }));
            return true;
        }
        return false;
    } catch (error) {
        handleApiError(error, dispatch, 'update features');
        return false;
    } finally {
        setUpdating(false);
    }
    };

    return { allFeatures, features, loading, fetchFeatures, updateFeatures, fetchAllFeatures };
}

export default useGetOrganization;